module.exports = __webpack_public_path__ + "img/korea.4debf870.png";